// src/pages/Tokushoho/Tokushoho.tsx
import React from 'react';
import HeadCommon from '../../components/HeadCommon';

const Tokushoho: React.FC = () => {
  return (
    <>
    <HeadCommon />
    <main
      className="Tokushoho-page other-page"
    >
      <h1>特定商取引法に基づく表記</h1>
      <section className="legal-info">
        <h2>販売業者</h2>
        <p>autoChat AI</p>

        <h2>運営統括責任者</h2>
        <ul>
          <li>三谷 達也</li>
          <li>津田 眞</li>
        </ul>

        <h2>所在地</h2>
        <p>
          ご請求時には販売者情報を遅延なく開示いたします。
          <br />
          お問い合わせフォームまたは下記メールからご連絡ください。
        </p>

        <h2>電話番号</h2>
        <p>
          ご請求時には販売者情報を遅延なく開示いたします。
          <br />
          お問い合わせフォームまたは下記メールからご連絡ください。
        </p>

        <h2>メールアドレス</h2>
        <p>
          <a href="mailto:support@auto-chat.ai">support@auto-chat.ai</a>
        </p>

        <h2>販売価格</h2>
        <p>
          Basicプラン：月額1,500円 〜 6,000円（税込）
          <br />
          Premiumプラン：月額3,500円 〜 14,000円（税込）
        </p>

        <h2>お支払い方法</h2>
        <p>
          クレジットカード決済
          <br />
          （その他の支払い方法は対応していません）
        </p>

        <h2>商品代金以外の必要料金</h2>
        <p>インターネット接続に必要な通信費などはお客様のご負担となります。</p>

        <h2>販売数量</h2>
        <p>特に制限はありません。</p>

        <h2>お申込みの有効期限</h2>
        <p>
          お申し込み後、7日以内にお支払いを完了してください。期限を過ぎた場合は、自動的にキャンセルとなります。
        </p>

        <h2>サービス提供時期</h2>
        <p>お支払い完了後、即時サービスをご利用いただけます。</p>

        <h2>返品・キャンセルについて</h2>
        <p>
          デジタルコンテンツという商品の性質上、返品・返金はお受けしておりません。
          <br />
          サービス開始後のキャンセルも同様にお受けできませんので、予めご了承ください。
        </p>

        <h2>動作環境</h2>
        <ul>
          <li>インターネット接続環境</li>
          <li>
            最新のWebブラウザ（Google Chrome、Mozilla Firefox、Safari、Microsoft
            Edge推奨）
          </li>
          <li>本サービスはPCおよびスマートフォンに対応しています。</li>
        </ul>

        <h2>解約について</h2>
        <p>
          有料会員プラン(「Basic」または「Premium」)は月額更新です。
          <br />
          解約をご希望の場合、次回更新日の前日までに「サブスクリプション管理」から解約手続きを行ってください。
          <br />
          解約手続き後は、翌月から課金が停止されます。
        </p>
      </section>
    </main>
    </>
  );
};

export default Tokushoho;
